import { render } from "./SpeechBubble.vue?vue&type=template&id=553507bf&scoped=true"
import script from "./SpeechBubble.vue?vue&type=script&lang=js"
export * from "./SpeechBubble.vue?vue&type=script&lang=js"

import "./SpeechBubble.vue?vue&type=style&index=0&id=553507bf&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Carla\\Projects\\Personal\\my-personal-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-553507bf"]])

export default __exports__